import axios from "axios";
import qs from "qs";
import { toast } from "react-toastify";
import { captureException } from "@sentry/react";
import ApiService from "./ApiService";
import AxiosHelper from "../utils/AxiosHelper";

const UserService = {
  signUpNaturalPerson: async (user: any) => {
    const request = {
      ...user,
      mobilePhone: user.mobilePhone.replace(/\D/g, ""),
      documentType: "CPF",
      documentNumber: user.documentNumber.replace(/\D/g, ""),
    };

    const signUpAPI = `${process.env.REACT_APP_DELEND_API}/auth/sign-up`;

    try {
      const response = await axios.post(signUpAPI, request);
      toast.success("Usuário criado com sucesso");
      return response;
    } catch (error: any) {
      toast.error(error.response.data.message);
      throw new Error(error);
    }
  },
  signUpLegalPerson: async (user: any) => {
    const request = {
      ...user,
      mobilePhone: user.mobilePhone.replace(/\D/g, ""),
      documentType: "CNPJ",
      documentNumber: user.documentNumber.replace(/\D/g, ""),
      responsibleCpf: user.responsibleCpf.replace(/\D/g, ""),
    };

    const signUpAPI = `${process.env.REACT_APP_DELEND_API}/auth/sign-up`;

    // try {
      const response = await axios.post(signUpAPI, request);
      toast.success("Bem vindo! Seu cadastro foi realizado com sucesso.");
      return response;
    // } catch (error: any) {
    //   // throw new Error(error);
    // }
  },
  login: async (user: any) => {

    const clearLocalStorage = async () => {
      const viewedTipsPersistance = localStorage.getItem("viewedTips");
      localStorage.clear();
      if (viewedTipsPersistance) {
        localStorage.setItem("viewedTips", "true");
      }
    };

    await clearLocalStorage();

    const loginAPI = `${process.env.REACT_APP_DELEND_API}/auth/token`;

    const request: any = {
      ...user,
      grant_type: "password",
    };

    const formData = new FormData();
    Object.keys(request).forEach((key) => {
      formData.append(key, request[key]);
    });

    const config = {
      method: "post",
      url: loginAPI,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: qs.stringify(request),
    };

    try {
      const response = await axios(config);
      const token = response.data.access_token;
      const refreshToken = response.data.refresh_token;

      if (!token) {
        alert("Unable to login. Please try after some time.");
        return;
      }

      localStorage.setItem("user-token", token);
      localStorage.setItem("user-refresh-token", refreshToken);
      return response;
    } catch (error: any) {
      if (error.response.status !== 401) {
        captureException(error);
        toast.error(error.response.data.errorDescription);
      }

      return error.response;
    }
  },
  refreshToken: async () => {
    const loginAPI = `${process.env.REACT_APP_DELEND_API}/auth/token`;
    const refreshToken = localStorage.getItem("user-refresh-token");

    const request: any = {
      grant_type: "refresh_token",
      refresh_token: refreshToken,
    };

    const formData = new FormData();
    Object.keys(request).forEach((key) => {
      formData.append(key, request[key]);
    });

    const config = {
      method: "post",
      url: loginAPI,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: qs.stringify(request),
    };

    try {
      const response = await axios(config);
      const token = response.data.access_token;
      const newRefreshToken = response.data.refresh_token;
      localStorage.setItem("user-token", token);
      localStorage.setItem("user-refresh-token", newRefreshToken);
      return response;
    } catch (error: any) {
      console.log("error no refresh token", error);
      return error.response.data;
    }
  },
  getUser: async () => {
    const response = await ApiService.get("auth/profile");
    if (response && response.data) {
      localStorage.setItem("subscriptionId", response.data.subscription.uuid);
    }
    return response.data;
  },
  forgotPassword: async (user: { username: string }) => {
    const request = user;

    const forgotPassword =
      process.env.REACT_APP_DELEND_API + "/auth/forgot-password";

    const config = {
      method: "post",
      url: forgotPassword,
      headers: {
        "Content-Type": "application/json",
      },
      data: { username: request.username },
    };

    try {
      const response = await axios(config);
      return response;
    } catch (error: any) {
      if (error.response) toast.error(error.response.data.message);
      throw new Error(error);
    }
  },
  changePassword: async (currentPassword: string, newPassword : string) => {

    const data = JSON.stringify({currentPassword, newPassword})

    const config = {
      method: "POST",
      maxBodyLength: Infinity,
      url: process.env.REACT_APP_DELEND_API + "/auth/change-password",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
   
    try {
      const response = await AxiosHelper.baseQueryWithRefresh(config);

      return response;
    } catch (error: any) {
      throw new Error(error.response.data.message);
    }

    
  },
};

export default UserService;
